    
<div class="Dialog-body">              
                  <div
                    style="display: flex; flex-direction: row; justify-content: space-between;margin-top: 1%; margin-left: auto;margin-right: auto;">
                    <textarea style="width: 400px; margin: auto;"  rows="4" [(ngModel)]="QuestionComment"
                      maxlength="256" placeholder="Comment"></textarea>
                    
                  </div>
                  <div class="buttonbelow">
                    <button mat-button (click) = "SaveQuestionComments()" >Submit</button>
                    <button mat-button  (click)="DialogClose()" >Cancel</button>    
                  </div>
</div>